export const ADMIN = 'Admin';
export const CUSTOMER = 'Customer';

export const USER_TYPES = [ADMIN, CUSTOMER];
